import script from "./TableTank.vue?vue&type=script&setup=true&lang=js"
export * from "./TableTank.vue?vue&type=script&setup=true&lang=js"

import "./TableTank.vue?vue&type=style&index=0&id=78cc07b6&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78cc07b6"]])

export default __exports__